import Vue from 'vue'
import Vuex from 'vuex'
import {arrSplice, dateFormats, objectifyArr} from "./codeFunctions";
import {format} from "date-fns";

Vue.use(Vuex);

export class Warning {
  constructor(warning = {}) {
    this.id = null
    this.name = null
    this.config = {
      offenses: []
    }
    this.document = null
    this.documentConfig = {}
    this.lastEditedBy = null
    Object.assign(this, warning)
  }
}

export class EmpStatus {
  constructor(status = {}) {
    this.id = null
    this.name = null
    this.restrictedActions = []
    Object.assign(this, status)
  }
}

const restrictedActionsList = [
  {id: 'rollCall', text: "Roll Call"},
  {id: 'clockIn', text: "Clock In"},
  {id: 'clockOut', text: "Clock Out"},
  {id: 'binScan', text: "Bin Scan"},
  {id: 'generalWork', text: "General Work"},
  {id: 'shiftClock', text: "Shift Clock In/Out"},
]

const store = new Vuex.Store({
  state() {
    return {
      showDisabledEmployees: false,
      empCode: 0,
      loggedIn: false,
      userID: null,
      blocks: [],
      emp: [],
      farms: [],
      piece_work: [],
      devices: [],
      varieties: [],
      users: [],
      barcodes: [],
      hrPins: [],
      contracts: [],
      empStatuses: [],
      warnings: [],
      shifts: [],
      showSyncNotifications: true,
      zoomRatio: 1,
      downloadImageOptions: {
        format: 'pdf',
        filename: 'id',
        identity: true,
        identityBack: true,
        recruitment: true,
        photo: true,
        clock: true,
        banking: true,
      },
      jobDescriptions: [],
    }
  },
  mutations: {
    setMailConfig(state, payload) {
      state.mailConfig = payload
    },
    login(state, payload) {
      state.loggedIn = payload !== false;
      state.userID = payload !== false ? payload : null;
    },
    upsertValues(state, payload) {
      function upsert(stateArr, obj) {
        if (typeof obj !== 'object') {
          console.log('Splice Happen', obj)

          arrSplice(stateArr, (val) => val.id === obj)
        } else {
          if (!obj?.id)
            return
          let added = false;
          for (const stateVar of stateArr) {
            if (stateVar.id === obj.id) {
              Object.assign(stateVar, obj)
              added = true;
            }
          }
          if (!added)
            stateArr.push(obj)
        }
      }

      for (const key of Object.keys(payload)) {
        if (typeof state[key] != 'undefined' && Array.isArray(payload[key])) {
          let objects = payload[key]
          for (const obj of objects) {
            upsert(state[key], obj)
          }
        }
      }
    },
  },
  actions: {
    setLogin(context, payload) {
      context.commit('login', payload)
    },
    upsert(context, payload) {
      context.commit('upsertValues', payload)
    }
  },
  getters: {
    loggedIn(state) {
      return state.loggedIn
    },
    userID(state) {
      return state.userID
    },

    restrictedActionsList() {
      return restrictedActionsList
    },

    warnings(state, getters) {


      return state.warnings.map(warning => {
        return new Warning(warning)
      })
    },
    warningsRef(state, getters) {
      return objectifyArr(getters.warnings, 'id')
    },

    jobDescriptions(state) {
      return state.jobDescriptions
    },
    jobDescriptionNames(state) {
      return state.jobDescriptions.map(jd => jd.description)
    },

    empStatuses(state, getters) {

      return state.empStatuses.map(status => {
        return new EmpStatus(status)
      })
    },
    empStatusesRef(state, getters) {
      return objectifyArr(getters.empStatuses, 'id')
    },

    blocks(state, getters) {
      class Block {
        constructor(block) {
          Object.assign(this, block)
          this.variety = getters.varieties.filter(variety => variety.id === block.fkVariety).pop()
        }

        get varietyDescription() {
          return this.variety ? this.variety.description || 'No Variety Set' : 'No Variety Set'
        }

        get blockDescription() {
          return this.description || 'No Block Name'
        }
      }

      return state.blocks.map(block => {
        return new Block(block)
      })
    },
    emp(state, getters) {

      class Emp {
        constructor(employee) {
          Object.assign(this, employee)
        }

        get farm() {
          return this.fkFarm ? getters.farmsRef[this.fkFarm] : {id: null, description: 'No Farm Set'}
        }

        get farmDescription() {
          return this.farm.description
        }
      }

      return state.emp.map(employee => {
        return new Emp(employee)
      })
    },
    empRef(state, getters) {
      return objectifyArr(getters.emp, 'id')
    },
    devices(state) {
      class Device {
        constructor(device) {
          Object.assign(this, device)
          this.lastSync = this.lastSync ? new Date(this.lastSync) : null
          this.created = this.created ? new Date(this.created) : null
        }

        get lastSyncDisplay() {
          return this.lastSync ? format(this.lastSync, dateFormats.longDate) : 'No Date Available'
        }

        get createdDisplay() {
          return this.created ? format(this.created, dateFormats.longDate) : 'No Date Available'
        }
      }

      return state.devices.map(device => {
        return new Device(device)
      })
    },
    devicesRef(state, getters) {
      return objectifyArr(getters.devices, "id")
    },
    availableFarms(state, getters) {
      class Farm {
        constructor(farm) {
          Object.assign(this, farm)
        }

        get varieties() {
          return getters.varieties.filter(obj => obj.fkFarm === null || obj.fkFarm === this.id)
        }

        get blocks() {
          return getters.blocks.filter((obj) => obj.fkFarm === this.id)
        }
      }

      return state.farms
        .filter(farm =>
          !getters.user.adminOptions
          || !getters.user.adminOptions.limitToFarms
          || getters.user.adminOptions.limitToFarms.length === 0
            ? true
            : getters.user.adminOptions.limitToFarms.includes(farm.id)
        )
        .map(obj => {
          return new Farm(obj)
        })
    },
    availableFarmIDs(state, getters) {
      return (getters.availableFarms.length ? getters.availableFarms : getters.farms).map((farm) => farm.id)
    },
    farms(state, getters) {
      class Farm {
        constructor(farm) {
          Object.assign(this, farm)
        }

        get varieties() {
          return getters.varieties.filter(obj => obj.fkFarm === null || obj.fkFarm === this.id)
        }

        get blocks() {
          return getters.blocks.filter((obj) => obj.fkFarm === this.id)
        }
      }

      return state.farms.map(obj => {
        return new Farm(obj)
      })
    },
    farmsRef(state, getters) {
      return objectifyArr(getters.farms, 'id')
    },
    contracts(state, getters) {
      class Contract {
        constructor(contract) {
          Object.assign(this, contract)
        }
      }

      return state.contracts.map(obj => {
        return new Contract(obj)
      })
    },
    contractsRef(state, getters) {
      return objectifyArr(getters.contracts, 'id')
    },
    hrPins(state, getters) {
      class HrPin {
        constructor(pin) {
          Object.assign(this, pin)
        }

        // get varieties() {
        //     return getters.varieties.filter(obj => obj.fkFarm === null || obj.fkFarm === this.id)
        // }
        // get blocks() {
        //     return getters.blocks.filter((obj) => obj.fkFarm === this.id)
        // }
      }

      return state.hrPins.map(obj => {
        return new HrPin(obj)
      })
    },
    hrPinsRef(state, getters) {
      return objectifyArr(getters.hrPins, 'id')
    },
    piece_work(state) {
      return state.piece_work
    },
    piece_workRef(state, getters) {
      return objectifyArr(getters.piece_work, 'id')
    },
    varieties(state, getters) {
      class Variety {
        constructor(variety) {
          Object.assign(this, variety)
        }

        get farm() {
          return this.fkFarm ? getters.farmsRef[this.fkFarm] : {id: null, description: 'All Farms'}
        }

        get farmDescription() {
          return this.farm.description
        }
      }

      return state.varieties.map(variety => {
        return new Variety(variety)
      })
    },
    users(state) {
      class User {
        constructor(user) {
          Object.assign(this, user)
        }

        get fullName() {
          return (this.name + ' ' + this.surname).trim();
        }

        get fullNameDisabled() {
          return `${this.fullName}${this.disabled ? ' (Disabled)' : ''}`
        }

        get barcodes() {
          return state.barcodes.filter(barcode => barcode.fkUser === this.id)
        }
      }

      return state.users.map(user => {
        return new User(user)
      })
    },
    usersRef(state, getters) {
      return objectifyArr(getters.users, 'id')
    },
    user(state, getters) {
      try {
        return getters.users.filter(obj => obj.id === state.userID).pop()
      } catch (e) {
        return null
      }
    },
    barcodes(state) {
      return state.barcodes
    },
    barcodesLookup(state, getters) {
      return objectifyArr(getters.barcodes, 'bCode')
    },
  }
});

export default store